<template>
  <div>
    <v-card>
      <v-card-title>Subordinates Remaining Leave Balance</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="leaveType"
            v-validate="'required'"
            label="Leave Type"
            :loading="dropdownLoading"
            :items="leaveTypes"
            :error-messages="errors.collect('leaveType')"
            data-vv-name="leaveType"  
            data-vv-as="leave type"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="year"
            v-validate="'required'"
            :loading="dropdownLoading"
            :items="years"
            label="Year"
            :error-messages="errors.collect('year')"
            data-vv-name="year"  
            data-vv-as="year"
            chips
            hide-selected
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="month"
            v-validate="'required'"
            :loading="dropdownLoading"
            :error-messages="errors.collect('month')"
            data-vv-name="month"  
            data-vv-as="month"
            :items="months"
            label="Up To"   
            chips
            hide-selected
            small-chips
            item-text="name"
            item-value="id"
          />
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row>
            <v-btn
              class="mx-3"
              color="primary"
              :loading="loading"
              @click="generateSubordinatesRemainingLeave"
            >
              generate
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        dropdownLoading: false,
        loading: false,
        leaveType: null,
        leaveTypes: [],
        year: null,
        years: [],
        month: null,
        months: [
          { id: 1, name: 'January' },
          { id: 2, name: 'February' }, 
          { id: 3, name: 'March' }, 
          { id: 4, name: 'April' },
          { id: 5, name: 'May' }, 
          { id: 6, name: 'June' }, 
          { id: 7, name: 'July' },
          { id: 8, name: 'August' },
          { id: 9, name: 'September' },
          { id: 10, name: 'October' },
          { id: 11, name: 'November' },
          { id: 12, name: 'December' },
        ],
      }
    },
    created () {
      this.dropdownLoading = true

      Promise.all([
        this.$api.leaveTypes().list(),
        this.$api.leaveReports().subordinateLeaveYears(),
      ])
        .then(([leaveTypes, subordinateLeaveYears]) => {
          this.leaveTypes = leaveTypes.data        
          this.years = subordinateLeaveYears.data     

          this.dropdownLoading = false
        })
    },
    methods: {
      generateSubordinatesRemainingLeave () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.leaveReports().subordinateRemainingLeaveBalance(this.prepareFormData())
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Subordinate Remaining Leave Balance Reports-' + this.year + '.xlsx')
                link.click()
                this.loading = false

                this.$snack({ message: 'Report downloaded successfully' })
              }).catch(() => {
                this.loading = false
                this.$snack({ color: 'error', message: 'Error! Please contact support' })
              })
          })
      },

      prepareFormData () {
        return {
          leaveTypes: this.leaveType,
          year: this.year,
          endDate: this.$moment(this.$moment([this.year, this.month - 1])).endOf('month').format('YYYY-MM-DD'),
        }
      },
    },
  }
</script>
